// ============================================================
// useNotifStore.ts — versione corretta
// BUG FIXATO #3:
//   dmUnread era presente nello store ma MAI alimentato dal polling.
//   Aggiunto incrementDmUnread per uso futuro e nota esplicita.
//   Il polling in apiClient.ts usa getTotalUnreadCount() che ora
//   include anche i DM tramite getDmUnreadCount().
// ============================================================
import { create } from 'zustand';

interface NotifState {
  boardUnread: number;
  eventUnread: number;
  dmUnread: number;
  inAppUnread: number;
  setBoardUnread: (n: number) => void;
  setEventUnread: (n: number) => void;
  setDmUnread: (n: number) => void;
  setInAppUnread: (n: number) => void;
  setAll: (board: number, event: number, dm: number, inApp?: number) => void;
  /** Incrementa dmUnread di 1 (usato quando arriva un nuovo DM in tempo reale) */
  incrementDmUnread: () => void;
}

const useNotifStore = create<NotifState>((set) => ({
  boardUnread: 0,
  eventUnread: 0,
  dmUnread: 0,
  inAppUnread: 0,
  setBoardUnread: (n) => set({ boardUnread: Math.max(0, n) }),
  setEventUnread: (n) => set({ eventUnread: Math.max(0, n) }),
  // BUG #3 FIX: setDmUnread ora è usato dal polling aggregato
  setDmUnread: (n) => set({ dmUnread: Math.max(0, n) }),
  setInAppUnread: (n) => set({ inAppUnread: Math.max(0, n) }),
  setAll: (board, event, dm, inApp) => set({
    boardUnread: Math.max(0, board),
    eventUnread: Math.max(0, event),
    dmUnread: Math.max(0, dm),
    inAppUnread: Math.max(0, inApp ?? 0),
  }),
  incrementDmUnread: () => set((state) => ({ dmUnread: state.dmUnread + 1 })),
}));

export default useNotifStore;
